(function () {
  'use strict';

  if (window.subcollectionFilterInitialized) return;
  window.subcollectionFilterInitialized = true;

  var states = new WeakMap();
  var responseCache = new Map();

  function getSection(root) {
    return root && root.closest('[data-section-type="collection-grid"]');
  }

  function getProducts(state) {
    return state.section.querySelector('[data-subcollection-products]');
  }

  function getState(root) {
    if (!root) return null;

    var existing = states.get(root);
    if (existing) return existing;

    var section = getSection(root);
    if (!section || !section.querySelector('[data-subcollection-products]')) return null;

    var state = {
      section: section,
      root: root,
      parentContent: null,
      activeHandle: '',
      activeTitle: '',
      activeUrl: '',
      activePage: '1',
      activeSort: '',
      abortController: null,
      requestId: 0
    };

    states.set(root, state);
    return state;
  }

  function label(root, name, title) {
    var value = root.dataset[name] || '';
    return value.replace('[title]', title || '');
  }

  function announce(state, message) {
    var region = state.root.querySelector('[data-subcollection-filter-announcement]');
    if (!region || !message) return;

    region.textContent = '';
    window.requestAnimationFrame(function () {
      region.textContent = message;
    });
  }

  function setLoading(state, loading) {
    var products = getProducts(state);
    if (!products) return;

    products.setAttribute('aria-busy', loading ? 'true' : 'false');

    var wrapper = products.querySelector('.collection-grid__wrapper');
    if (wrapper) wrapper.classList.toggle('unload', loading);
  }

  function setActiveUi(state, active) {
    var status = state.root.querySelector('[data-subcollection-filter-status]');
    var title = state.root.querySelector('[data-subcollection-filter-title]');
    var clear = state.root.querySelector('[data-subcollection-filter-clear]');

    state.root.querySelectorAll('[data-subcollection-filter-link]').forEach(function (link) {
      if (active && link.dataset.subcollectionHandle === state.activeHandle) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });

    state.section.classList.toggle('is-subcollection-filtered', active);

    if (!status || !title || !clear) return;
    status.hidden = !active;
    title.textContent = active ? state.activeTitle : '';
    clear.setAttribute(
      'aria-label',
      active
        ? label(state.root, 'labelClearNamed', state.activeTitle)
        : label(state.root, 'labelClear')
    );
  }

  function buildRequestUrl(state, collectionUrl, page, sortBy) {
    var requestUrl = new URL(collectionUrl, window.location.origin);

    requestUrl.searchParams.delete('section_id');
    requestUrl.searchParams.delete('page');
    requestUrl.searchParams.delete('sort_by');

    if (page && page !== '1') requestUrl.searchParams.set('page', page);
    if (sortBy) requestUrl.searchParams.set('sort_by', sortBy);
    requestUrl.searchParams.set('section_id', state.root.dataset.sectionId);

    return requestUrl;
  }

  function buildFallbackUrl(collectionUrl, page, sortBy) {
    var fallbackUrl = new URL(collectionUrl, window.location.origin);

    fallbackUrl.searchParams.delete('section_id');
    fallbackUrl.searchParams.delete('page');
    fallbackUrl.searchParams.delete('sort_by');

    if (page && page !== '1') fallbackUrl.searchParams.set('page', page);
    if (sortBy) fallbackUrl.searchParams.set('sort_by', sortBy);

    return fallbackUrl.toString();
  }

  function parseGrid(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var products = parsed.querySelector('[data-subcollection-products]');
    return products ? products.innerHTML : '';
  }

  function fetchGrid(state, collectionUrl, page, sortBy) {
    var requestUrl = buildRequestUrl(state, collectionUrl, page, sortBy);
    var cacheKey = requestUrl.toString();

    if (state.abortController) state.abortController.abort();

    if (responseCache.has(cacheKey)) {
      state.abortController = null;
      return Promise.resolve(responseCache.get(cacheKey));
    }

    state.abortController = new AbortController();

    return fetch(cacheKey, {
      credentials: 'same-origin',
      signal: state.abortController.signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load subcollection');
        return response.text();
      })
      .then(function (html) {
        var gridHtml = parseGrid(html);
        if (!gridHtml) throw new Error('Subcollection grid was not found');
        responseCache.set(cacheKey, gridHtml);
        return gridHtml;
      });
  }

  function initScopedColorSwatches(scope) {
    scope.querySelectorAll('.color-swatch--with-image').forEach(function (swatch) {
      if (swatch.dataset.subcollectionSwatchBound === 'true') return;
      swatch.dataset.subcollectionSwatchBound = 'true';

      swatch.addEventListener('mouseenter', function () {
        var product = swatch.closest('.grid-product');
        var image = product && product.querySelector(
          '.grid-product__color-image--' + swatch.dataset.variantId
        );
        if (!image) return;

        image.style.backgroundImage = 'url(' + swatch.dataset.variantImage + ')';
        image.classList.add('is-active');
      });

      swatch.addEventListener('mouseleave', function () {
        var product = swatch.closest('.grid-product');
        var image = product && product.querySelector(
          '.grid-product__color-image--' + swatch.dataset.variantId
        );
        if (image) image.classList.remove('is-active');
      });
    });
  }

  function reinitializeGrid(state) {
    var products = getProducts(state);
    if (!products) return;

    if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
      window.theme.reinitProductGridItem(products);
    }

    initScopedColorSwatches(products);
    document.dispatchEvent(new CustomEvent('collection:reloaded', {
      detail: { source: 'subcollection-filter' }
    }));
  }

  function replaceWithSubcollection(state, gridHtml) {
    var products = getProducts(state);
    if (!products) return false;

    if (!state.parentContent) {
      state.parentContent = document.createDocumentFragment();
      while (products.firstChild) {
        state.parentContent.appendChild(products.firstChild);
      }
    }

    products.innerHTML = gridHtml;
    reinitializeGrid(state);
    return true;
  }

  function restoreParentGrid(state) {
    var products = getProducts(state);
    if (!products || !state.parentContent) return;

    products.innerHTML = '';
    products.appendChild(state.parentContent);
    state.parentContent = null;

    document.dispatchEvent(new CustomEvent('collection:reloaded', {
      detail: { source: 'subcollection-filter' }
    }));
  }

  function updateUrl(state, page, sortBy, replaceHistory) {
    var url = new URL(window.location.href);
    url.searchParams.set('subcollection', state.activeHandle);

    if (page && page !== '1') {
      url.searchParams.set('subcollection_page', page);
    } else {
      url.searchParams.delete('subcollection_page');
    }

    if (sortBy) {
      url.searchParams.set('subcollection_sort', sortBy);
    } else {
      url.searchParams.delete('subcollection_sort');
    }

    url.searchParams.delete('page');
    var method = replaceHistory ? 'replaceState' : 'pushState';
    window.history[method]({}, '', url.pathname + url.search + url.hash);
  }

  function scrollToProducts(state) {
    var products = getProducts(state);
    if (!products) return;

    var header = document.querySelector('.site-header');
    var offset = header ? header.offsetHeight + 15 : 15;
    var top = products.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function focusUpdatedControl(state, target) {
    var products = getProducts(state);
    if (!products || !target) return;

    if (target === 'sort') {
      var sort = products.querySelector('#SortBy');
      if (sort) sort.focus({ preventScroll: true });
      return;
    }

    if (target === 'results') {
      var heading = products.querySelector('.collection-filter__results-heading');
      var focusTarget = heading || products;
      focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus({ preventScroll: true });
      focusTarget.addEventListener('blur', function removeTemporaryTabindex() {
        focusTarget.removeAttribute('tabindex');
      }, { once: true });
    }
  }

  function announceResults(state) {
    var products = getProducts(state);
    var heading = products && products.querySelector('.collection-filter__results-heading');
    var message = label(state.root, 'labelShowing', state.activeTitle);

    if (heading && heading.textContent.trim()) {
      message += '. ' + heading.textContent.trim();
    }

    announce(state, message);
  }

  function activate(state, options) {
    var page = options.page || '1';
    var sortBy = options.sortBy || '';
    var requestId = state.requestId + 1;
    state.requestId = requestId;

    state.activeHandle = options.handle;
    state.activeTitle = options.title;
    state.activeUrl = options.url;
    state.activePage = page;
    state.activeSort = sortBy;

    setActiveUi(state, true);
    setLoading(state, true);
    announce(state, label(state.root, 'labelLoading', state.activeTitle));

    return fetchGrid(state, state.activeUrl, page, sortBy)
      .then(function (gridHtml) {
        if (requestId !== state.requestId) return;
        if (!replaceWithSubcollection(state, gridHtml)) {
          throw new Error('Subcollection product target was not found');
        }

        setActiveUi(state, true);
        announceResults(state);

        if (options.updateHistory !== false) {
          updateUrl(state, page, sortBy, options.replaceHistory);
        }

        if (options.scroll !== false) scrollToProducts(state);
        focusUpdatedControl(state, options.focusTarget);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        if (requestId === state.requestId) {
          window.location.assign(buildFallbackUrl(options.url, page, sortBy));
        }
      })
      .finally(function () {
        if (requestId === state.requestId) setLoading(state, false);
      });
  }

  function clear(state, updateHistory) {
    if (state.abortController) state.abortController.abort();
    state.requestId += 1;

    restoreParentGrid(state);
    state.activeHandle = '';
    state.activeTitle = '';
    state.activeUrl = '';
    state.activePage = '1';
    state.activeSort = '';

    setLoading(state, false);
    setActiveUi(state, false);
    announce(state, label(state.root, 'labelShowingAll'));

    if (updateHistory !== false) {
      var url = new URL(window.location.href);
      url.searchParams.delete('subcollection');
      url.searchParams.delete('subcollection_page');
      url.searchParams.delete('subcollection_sort');
      window.history.pushState({}, '', url.pathname + url.search + url.hash);
    }
  }

  function findLink(root, handle) {
    return Array.from(root.querySelectorAll('[data-subcollection-filter-link]')).find(function (link) {
      return link.dataset.subcollectionHandle === handle;
    });
  }

  function activateFromUrl(root, scroll) {
    var params = new URLSearchParams(window.location.search);
    var handle = params.get('subcollection');
    if (!handle) return false;

    var link = findLink(root, handle);
    var state = getState(root);
    if (!link || !state) return false;

    activate(state, {
      handle: handle,
      title: link.dataset.subcollectionTitle,
      url: link.href,
      page: params.get('subcollection_page') || '1',
      sortBy: params.get('subcollection_sort') || '',
      updateHistory: false,
      scroll: scroll
    });

    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-subcollection-filter-link]');
    if (link) {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) return;

      var root = link.closest('[data-subcollection-filter-root]');
      var state = getState(root);
      if (!state) return;

      event.preventDefault();
      activate(state, {
        handle: link.dataset.subcollectionHandle,
        title: link.dataset.subcollectionTitle,
        url: link.href
      });
      return;
    }

    var clearButton = event.target.closest('[data-subcollection-filter-clear]');
    if (clearButton) {
      var clearRoot = clearButton.closest('[data-subcollection-filter-root]');
      var clearState = getState(clearRoot);
      if (!clearState) return;

      event.preventDefault();
      clear(clearState, true);
      return;
    }

    var paginationLink = event.target.closest('.pagination a');
    if (!paginationLink) return;

    var activeSection = paginationLink.closest('.collection-content.is-subcollection-filtered');
    var activeRoot = activeSection && activeSection.querySelector('[data-subcollection-filter-root]');
    var activeState = getState(activeRoot);
    if (!activeState || !activeState.activeHandle) return;

    event.preventDefault();
    var pageUrl = new URL(paginationLink.href, window.location.origin);
    activate(activeState, {
      handle: activeState.activeHandle,
      title: activeState.activeTitle,
      url: activeState.activeUrl,
      page: pageUrl.searchParams.get('page') || '1',
      sortBy: activeState.activeSort,
      focusTarget: 'results'
    });
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('#SortBy')) return;

    var activeSection = event.target.closest('.collection-content.is-subcollection-filtered');
    var root = activeSection && activeSection.querySelector('[data-subcollection-filter-root]');
    var state = getState(root);
    if (!state || !state.activeHandle) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    activate(state, {
      handle: state.activeHandle,
      title: state.activeTitle,
      url: state.activeUrl,
      sortBy: event.target.value,
      page: '1',
      scroll: false,
      focusTarget: 'sort'
    });
  }, true);

  window.addEventListener('popstate', function (event) {
    var handled = false;

    document.querySelectorAll('[data-subcollection-filter-root]').forEach(function (root) {
      var state = getState(root);
      if (!state) return;

      var hasUrlState = new URLSearchParams(window.location.search).has('subcollection');
      if (!hasUrlState && !state.activeHandle) return;

      handled = true;
      if (!activateFromUrl(root, false) && state.activeHandle) {
        clear(state, false);
      }
    });

    if (handled) event.stopImmediatePropagation();
  }, true);

  function init() {
    document.querySelectorAll('[data-subcollection-filter-root]').forEach(function (root) {
      if (root.dataset.subcollectionFilterReady === 'true') return;
      root.dataset.subcollectionFilterReady = 'true';
      getState(root);
      activateFromUrl(root, false);
    });
  }

  document.addEventListener('collection:reloaded', init);
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
